// removed by extract-text-webpack-plugin
module.exports = {"flexCol":"FieldStacked__flexCol","inputGroup":"FieldStacked__inputGroup","subHeader":"FieldStacked__subHeader"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FieldStacked/FieldStacked.scss
// module id = ./src/components/FieldStacked/FieldStacked.scss
// module chunks = 2